import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJetComponent } from './simple-icons-jet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJetComponent ],
    exports:      [ SimpleIconsJetComponent ],
    bootstrap:    []
})
export class SimpleIconsJetModule {}
